/* eslint-disable */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import { toast } from 'react-hot-toast';
import api from '../services/api';
import logo from '../assets/Logo.png';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    // Email validation
    const regEx = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;
    if (!regEx.test(email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      const formdata = {
        email: email,
      };
      
      // You'll need to add this method to your api service
      const response = await api.forgotPassword(formdata);
      
      if (response.status === 'success') {
        toast.success(response.message || 'Password reset instructions sent to your email');
        setEmailSent(true);
      } else {
        toast.error(response.message || 'Failed to send reset instructions');
      }
    } catch (error) {
      toast.error("Failed to send reset instructions");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Show success message if email was sent
  if (emailSent) {
    return (
      <div className="flex justify-center sm:items-center w-screen h-screen pt-44 sm:pt-0">
        <div className="w-[370px] space-y-5">
          <div className="flex justify-center">
            <img src={logo} alt="logo not found" className="h-20 w-20" />
          </div>
          <div className="flex justify-center">
            <h3>Reset Password</h3>
          </div>
          <div className="text-justify">
            We have sent you an email with instructions to reset your password.
            If you don't see an email from in your inbox, please check your spam folder or try a 
            different email address.
          </div>
          <div className="flex justify-center text-[#3975CB]">
            <Link to="/" className="forgot_password_back">
              Return to Sign in
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // Show the form if email hasn't been sent yet
  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4 sm:p-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <img 
            src="https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2025-03-18/full_logo.a46683a620fa53c3c554_1742299090688.png" 
            alt="SalesCaptain Logo" 
            className="h-10 object-contain"
          />
        </div>
        
        <h1 className="text-2xl font-semibold text-center mb-2">
          Forgot Password
        </h1>
        <p className="text-gray-500 text-center mb-8">
          To reset your account password, enter the email address you registered with, and we will email you the instructions to reset the password.
        </p>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 h-5 w-5" />
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="pl-10 h-12 w-full border border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none"
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="w-full h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-lg flex items-center justify-center"
            disabled={loading}
          >
            {loading ? (
              <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent mr-2"></div>
            ) : null}
            Send Instructions
          </button>
        </form>
        
        <div className="mt-8 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-800 text-sm"
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            Return to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 